module.exports = __webpack_public_path__ + "img/1.807128b3.png";